import { useEffect, useState } from "react";
import { ShieldCheck, ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function LegalUpdateBanner() {
  const [updates, setUpdates] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    // Deferred: compliance banners are not needed for first paint.
    const t = setTimeout(() => {
      api.get("/legal/updates").then((r) => setUpdates(r.data.updates || [])).catch(() => {});
    }, 3000);
    return () => clearTimeout(t);
  }, []);

  if (updates.length === 0) return null;
  const titles = updates.map((u) => u.title).join(" & ");

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/legal/acknowledge", { slug: "all", source: window.location.pathname });
      setUpdates([]);
      toast.success("Thank you, your acceptance has been recorded.");
    } catch { toast.error("Could not record your acceptance. Please try again."); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="legal-update-banner" className="mb-5 flex flex-wrap items-center gap-3 rounded-2xl border border-[#0F766E]/20 bg-[#0F766E]/5 px-4 py-3 dark:border-[#2dd4bf]/20 dark:bg-[#2dd4bf]/10">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#0F766E]/15"><ShieldCheck className="h-5 w-5 text-[#0F766E] dark:text-[#2dd4bf]" /></span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-[#2D3436] dark:text-white">We've updated our {titles}</div>
        <div className="text-xs text-[#636E72] dark:text-gray-300">Please review and accept the latest version to continue. Your acceptance is recorded for compliance.</div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {updates.map((u) => (
          <a key={u.slug} data-testid={`legal-update-link-${u.slug}`} href={u.url} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-1 rounded-lg border border-[#0F766E]/30 px-3 py-1.5 text-xs font-medium text-[#0F766E] hover:bg-[#0F766E]/5 dark:text-[#2dd4bf]">
            Review {u.title} <ArrowRight className="h-3.5 w-3.5" />
          </a>
        ))}
        <button data-testid="legal-update-accept" onClick={accept} disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-lg bg-[#0F766E] px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-[#0d655e] disabled:opacity-60">
          <Check className="h-3.5 w-3.5" /> {busy ? "Saving…" : "I've reviewed & accept"}
        </button>
      </div>
    </div>
  );
}
